module.exports = __webpack_public_path__ + "static/media/profile-bg.baf6b40a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/profile-bg.jpg
// module id = 5942
// module chunks = 0